type Listener = (conversationId: string) => void;

const listeners = new Set<Listener>();

/** A durable-ledger hint only: consumers re-fetch the authorized aggregate. */
export function notifyExecutionUsageUpdated(conversationId: string): void {
  if (!conversationId) return;
  for (const listener of listeners) listener(conversationId);
}

export function subscribeExecutionUsageUpdates(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
